import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

const propTypes = {
  children: PropTypes.element.isRequired,
  time: PropTypes.string.isRequired,
};

const TimeTextLine = ({ children, time }) => {
  return (
    <div className="TimeTextLine">
      <div>
        <strong>{children}:</strong>
      </div>
      <div>
        <FormattedDate
          value={new Date(time)}
          year="numeric"
          month="long"
          day="2-digit"
          hour="numeric"
          minute="numeric"
        />
      </div>
    </div>
  );
};

TimeTextLine.propTypes = propTypes;

export default TimeTextLine;



// WEBPACK FOOTER //
// ../ui-components/components/TimeTextLine/index.jsx